import { Box, Button } from "@mui/material";
import React from "react";
import LoadingButton from "../../../../components/LoadingButton";

interface StepNavButtonsProps {
  onBack: () => void;
  onNext: () => void;
  nextLabel?: string;
  // When set, the Continue button shows a spinner and Back is disabled (used while the
  // final step persists completion before navigating away).
  nextLoading?: boolean;
}

// Shared Back / Continue footer for the guided onboarding preview steps.
export default function StepNavButtons({
  onBack,
  onNext,
  nextLabel = "Continue",
  nextLoading = false,
}: StepNavButtonsProps) {
  return (
    <Box sx={{ display: "flex", gap: 2, mt: 4 }}>
      <Button
        variant="outlined"
        onClick={onBack}
        disabled={nextLoading}
        sx={{ px: 3 }}
      >
        Back
      </Button>
      <LoadingButton
        variant="contained"
        onClick={onNext}
        loading={nextLoading}
        sx={{ px: 4, fontWeight: 600, textTransform: "none" }}
      >
        {nextLabel}
      </LoadingButton>
    </Box>
  );
}
